<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">{{total}} Purchases</h4>
                                <h6 class="card-subtitle">List of purchases available in your marketplace.</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'newpo'}"
                                                     class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Purchase
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <div class="col-4">
                                    <multiselect
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="true"
                                            :limit="3"
                                            :max-height="600"
                                            :options="suppliers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchSuppliers"
                                            class="form-control multiselect-sm"
                                            data-vv-as="buyer"
                                            id="supplier"
                                            label="supplier"
                                            name="supplier"
                                            open-direction="bottom"
                                            placeholder="Search Supplier"
                                            track-by="id"
                                            v-if="currentOrg.type === 'COOP'"
                                            v-model="filter.supplier">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Purchaser not found</span>
                                    </multiselect>
                                    <multiselect
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :options="buyers"
                                            :searchable="true"
                                            :selectLabel="''"
                                            :show-no-results="false"
                                            @search-change="searchBuyers"
                                            class="form-control multiselect-sm"
                                            id="buyer"
                                            label="Buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            v-if="currentOrg.type === 'COOP_MEMBER'"
                                            v-model="filter.buyer">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.biz_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                                <div>{{ props.option.biz_name }}</div>
                                                <div>{{ props.option.biz_email }}</div>
                                            </div>
                                        </template>
                                        <span slot="noResult">Buyer not found</span>
                                    </multiselect>
                                </div>
                                <div class="col-4">
                                    <multiselect
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="true"
                                            :limit="3"
                                            :max-height="600"
                                            :options="members"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchMembers"
                                            class="form-control  multiselect-sm"
                                            data-vv-as="did"
                                            id="did"
                                            label="short_name"
                                            name="member_id"
                                            open-direction="bottom"
                                            placeholder="Search Member"
                                            track-by="did"
                                            v-model="filter.member">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.short_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.short_name }}</h5>
                                                <div>{{ props.option.did | hex_format(10, '.....') }}</div>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-2">
                                    <select class="custom-select" id="inlineFormCustomSelect"
                                            v-model="filter.status">
                                        <option value="">Choose Status</option>
                                        <option
                                                v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">{{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-2">
                                    <input
                                            class="form-control"
                                            name="purchase"
                                            placeholder="Purchase Order #"
                                            type="text"
                                            v-model="filter.poid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-2">
                                    <input class="form-control" id="startdate" placeholder="Start Date" type="text"/>
                                </div>
                                <div class="col-2">
                                    <input class="form-control" id="enddate" placeholder="End Date" type="text"/>
                                </div>
                                <div class="col-2">
                                    <div class="btn-group" style="display: flex;">
                                        <button @click="searchPo(1)"
                                                class="btn btn-light btn-outline-success font-weight-bold" style="flex: 1"
                                                type="button">
                                            <i class="fa fa-search"/> Go!
                                        </button>
                                        <button @click="reset()"
                                                class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                style="flex: 1" type="button">
                                            <i class="fa fa-undo"/> Reset
                                        </button>
                                    </div>
                                </div>
                                <div class="col-2 text-right ml-auto">
<!--                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ...">-->
<!--                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>-->
<!--                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>-->
<!--                                        </span>-->
                                    <button aria-expanded="false" aria-haspopup="true"
                                            class="btn waves-effect waves-light btn-outline-info"
                                            data-toggle="dropdown" title="Operations">
                                        <i class="fa fa-grip-vertical"/>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a @click="poCheckout(checkedPos)" class="dropdown-item"
                                           href="javascript:void(0)" v-if="currentOrg.type === 'COOP'">Checkout</a>
                                        <div class="dropdown-divider" v-if="currentOrg.type === 'COOP'"></div>
                                        <a @click="exportPos()" class="dropdown-item" href="javascript:void(0)">
                                            <json-c-s-v
                                                :data="exportedPos"
                                                :name="pos_export_name">
                                                Export as CSV
                                            </json-c-s-v>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive m-t-30" v-if="purchases.length>0">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label" for="records" style="padding-left: 10px;">Display
                                        Maximum</label>
                                    <div class="col-sm-2" style="padding-top: 5px;">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                                class="form-control form-control-sm" id="records" name="lang_opt_length"
                                                v-model="perPage">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0" style="width: 0px;">
                                        <div class="form-check">
                                            <input
                                                    @change="checkAll($event)"
                                                    class="form-check-input"
                                                    id="checkAll"
                                                    type="checkbox">
                                            <label class="form-check-label" for="checkAll"></label>
                                        </div>
                                    </th>
<!--                                    <th class="border-0"><h6>#</h6></th>-->
                                    <th class="border-0"><h6>Status</h6></th>
                                    <th class="border-0"><h6>Number</h6></th>
                                    <th class="border-0" v-if="currentOrg.type === 'COOP'"><h6>Counter party</h6></th>
                                    <th class="border-0" v-if="currentOrg.type === 'COOP_MEMBER'"><h6>Buyer</h6></th>
                                    <th class="border-0"><h6>Amount Due</h6></th>
                                    <th class="border-0"><h6>Created At</h6></th>
                                    <th class="border-0"><h6>Actions</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(p, index) in purchases">
                                    <td class="sorting_1">
                                        <div class="form-check">
                                            <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    v-bind:id="p.id"
                                                    v-bind:value="p"
                                                    v-model="checkedPos">
                                            <label class="form-check-label" v-bind:for="p.id"></label>
                                        </div>
                                    </td>
<!--                                    <td>{{index+1}}</td>-->
                                    <td>
                                        <dd class="mb-1">
                                            <p v-if="p.status === 'DRAFT'"><span class="label label-cyan">Draft</span>
                                            </p>
                                            <p v-if="p.status === 'ISSUED'"><span class="label label-info">Issued</span>
                                            </p>
                                            <p v-if="p.status === 'CANCELLED'"><span class="label label-inverse">Cancelled</span>
                                            </p>
                                            <p v-if="p.status === 'RECEIVED'"><span class="label label-light-green">Received</span>
                                            </p>
                                            <p v-if="p.status === 'PARTIALLY_RECEIVED'"><span
                                                    class="label label-light-green">Received Partial</span></p>
                                            <p v-if="p.status === 'PAID'"><span
                                                    class="label label-dark-green">Paid</span></p>
                                        </dd>
                                    </td>
                                    <td>{{p.po_number}}</td>
                                    <td v-if="p.member_did && p.member_catalog">
                                        <did-details :catalog="p.member_catalog" :did="p.member_did"
                                                     :show_blockie="true"></did-details>
                                    </td>
                                    <td v-else-if="currentOrg.type === 'COOP'">
                                        <blockie :address="p.supplier.biz_email"/>
                                        <span class="m-l-10">{{p.supplier.biz_name |
                                            capitalize}}</span>
                                    </td>
                                    <td v-else-if="currentOrg.type === 'COOP_MEMBER'">
                                        <blockie :address="p.buyer.biz_email"/>
                                        <span class="m-l-10"> {{p.buyer.biz_name | capitalize}}</span>
                                    </td>
                                    <td v-if="p.status === 'PAID'">{{p.total.currency_symbol}}0.00</td>
                                    <td v-if="p.status !== 'PAID'">{{p.total | money}}</td>
                                    <td>{{p.created_at | medium}}</td>
                                    <td>

                                        <router-link :to="{'name': 'viewpo', params: {poid: p.id}}">
                                            <i class="fas fa-eye m-10"></i>
                                        </router-link>
                                        <router-link :to="{'name': 'edit-po', params: {poid: p.id}}"
                                                     v-if="p.status === 'DRAFT'">
                                            <i class="fas fa-pencil-alt text-primary"></i>
                                        </router-link>
                                        <i @click="removePoId = p.id" class="far fa-trash-alt text-danger m-l-10"
                                           data-target="#confirmModal" data-toggle="modal" style="cursor: pointer"
                                           v-if="p.status === 'DRAFT'"></i>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-body" v-else>
                            <h4 class="card-title text-muted text-center">No records found</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>

        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog"
             tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this Purchase Order?</h4>
                            <button @click="removePurchase" class="btn waves-effect waves-light btn-success m-r-15"
                                    data-dismiss="modal" type="button">Yes
                            </button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import _ from 'lodash';
    import JsonCSV from 'vue-json-csv';
    import DidDetails from "../../common/DidDetails";

    export default {
        name: "Purchases",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {DidDetails, Blockie, Paginate, Multiselect, JsonCSV},
        data() {
            return {
                statuses: ['DRAFT', 'ISSUED', 'CANCELLED', 'RECEIVED', 'PARTIALLY_RECEIVED', 'PAID'],
                $BORLAUG: this.$BORLAUG,
                suppliers: [],
                buyers: [],
                members: [],
                filter: {
                    supplier: null,
                    member: null,
                    buyer: null,
                    status: "",
                    fromDate: "",
                    toDate: "",
                    poid: ""
                },
                isFiltered: false,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                purchases: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                checkedPos: [],
                exportedPos: [],
                pos_export_name: "Purchase_Report.csv",
                perPage: 5,
                removePoId: null
            };
        },
        watch: {
            checkedPos: function (val) {
                let cnt = 0;
                this.exportedPos = [];
                val.forEach(cpo => {
                    let obj = {};
                    if (this.currentOrg.type === 'COOP') {
                        obj = {
                            '#': cnt + 1,
                            'Purchase Order Id': cpo.id,
                            'Supplier Name': cpo.supplier.biz_name,
                            'Status': cpo.status,
                            'Price': cpo.total.currency_symbol + cpo.total.amount,
                            'Created at': moment(Date.parse(cpo.created_at)).format("MMMM Do YYYY, h:mm:ss a")
                        }
                    } else if (this.currentOrg.type === 'COOP_MEMBER') {
                        obj = {
                            '#': cnt + 1,
                            'Purchase Order Id': cpo.id,
                            'Buyer Name': cpo.buyer.biz_name,
                            'Status': cpo.status,
                            'Price': cpo.total.currency_symbol + cpo.total.amount,
                            'Created at': moment(Date.parse(cpo.created_at)).format("MMMM Do YYYY, h:mm:ss a")
                        }
                    }
                    this.exportedPos.push(obj);
                    cnt++;
                })
            }
        },
        mounted() {
            this.getPurchases(1);

            let self = this;
            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.fromDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.fromDate = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.filter.toDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.filter.toDate = null;
                        }
                    });
            });
        },
        methods: {
            async searchMembers(searchText) {
                let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=1000`);
                this.members = data.dids;
            },
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate = e[1].toDate();
            },
            async getPurchases(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases`, {
                            params: {
                                page: page,
                                perPage: this.perPage
                            }
                        });
                    $(".preloader").fadeOut();
                    this.total = reply.data.total;
                    this.purchases = reply.data.purchases;
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if (min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate = moment(min_date).format('YYYY-MM-DD');
                    } else if (this.purchases.length === 1) {
                        this.startDate = moment(this.purchases[0].created_at).format('YYYY-MM-DD');
                        this.endDate = moment(this.purchases[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.isFiltered = false;
                    this.setPageCount();
                } catch (e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                }
            },
            pageHandler(pageNum) {
                this.getPurchases(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            viewPurchaseOrder(poid) {
                this.$router.push({name: "viewpo", params: {poid: poid}});
            },
            viewTx(tx) {
                console.log(tx);
            },
            viewContract(contract) {
                console.log(contract);
            },
            async searchSuppliers(searchText) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/supplier/search`, {
                            params: {
                                search: searchText
                            }
                        });
                    this.suppliers = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchBuyers(searchText) {
                try {
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/buyer/search`, {
                            params: {
                                search: searchText
                            }
                        });
                    this.buyers = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchPo(page) {
                try {
                    $(".preloader").fadeIn();
                    this.filter.supplier = this.filter.supplier ? this.filter.supplier : {};
                    this.filter.buyer = this.filter.buyer ? this.filter.buyer : {};
                    this.filter.member = this.filter.member ? this.filter.member : {};
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${JSON.stringify(this.filter)}/search`, {
                            params: {
                                page: page,
                                perPage: this.perPage
                            }
                        });
                    $(".preloader").fadeOut();
                    this.total = reply.data.total;
                    this.purchases = reply.data.purchases;
                    // let max_date = reply.data.min_date;
                    // let min_date = reply.data.max_date;
                    // if (min_date && max_date) {
                    //     this.startDate = moment(max_date).format('YYYY-MM-DD');
                    //     this.endDate = moment(min_date).format('YYYY-MM-DD');
                    // } else if (this.purchases.length === 1) {
                    //     this.startDate = moment(this.purchases[0].created_at).format('YYYY-MM-DD');
                    //     this.endDate = moment(this.purchases[0].created_at).format('YYYY-MM-DD');
                    // } else {
                    //     this.startDate = moment(new Date()).format('YYYY-MM-DD');
                    //     this.endDate = moment(new Date()).format('YYYY-MM-DD');
                    // }
                    this.isFiltered = true;
                    this.setPageCount();
                } catch (e) {
                    console.log(e);
                }
            },
            async reset() {
                this.filter.supplier = null;
                this.filter.buyer = null;
                this.filter.member = null;
                this.filter.status = "";
                this.filter.fromDate = "";
                this.filter.toDate = "";
                this.filter.poid = "";
                await this.getPurchases(1);
            },
            poCheckout(checkedPos) {
                if (this.checkedPos.length === 0) {
                    this.$toastr('warning', 'Choose at least one Purchase order to perform the operation', 'Warning');
                    return;
                }
                let supplier = _.uniqBy(checkedPos, 'supplier.id');
                let receivedPos = _.filter(checkedPos, {
                    status: 'RECEIVED'
                });
                let paidPos = _.filter(checkedPos, {
                    status: 'PAID'
                });
                if (supplier.length !== 1) {
                    this.$toastr('error', 'You cant checkout with different supplier simultaneously', 'Failed');
                } else if (paidPos.length > 0) {
                    this.$toastr('error', 'Already paid', 'Failed');
                } else if (receivedPos.length !== checkedPos.length) {
                    this.$toastr('error', 'Purchase order should be in RECEIVED status to pay', 'Failed');
                } else {
                    this.$router.push({name: 'pocheckout', params: {checkedPos}});
                }
            },
            checkAll(e) {
                if (e.target.checked) {
                    this.checkedPos = this.purchases
                } else {
                    this.checkedPos = []
                }
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.searchPo(1);
                } else {
                    this.getPurchases(1);
                }
            },
            exportPos() {
                if (this.checkedPos.length === 0) {
                    this.$toastr('warning', 'Choose at least one Purchase order to perform the operation', 'Warning');
                }
            },
            async removePurchase() {
                try {
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/purchases/${this.removePoId}`);
                    this.$toastr('success', 'PO deleted', 'Success');
                    await this.getPurchases(1);
                } catch (e) {
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            }
        }
    }
</script>

<style scoped>
    .btn-arrange {
        margin-left: 4px !important;
    }

    .custom-go {
        height: 42px;
        margin-left: 5px;
    }
</style>
